// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"5025a623","81":"5025a623","279":"5025a623","976":"5025a623"}[chunkId] + ".chunk.css";
};